import { useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import getBackendURL from "./getBackendURL";

/**
 * Presentational form for entering the school code. No header, no routing.
 * Parent (Dashboard) provides onSuccess when code is accepted.
 */
export default function EnterCodeForm({ onSuccess }) {
  const { getToken } = useAuth();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const trimmed = code.trim();
    if (!trimmed) {
      setError("Bitte geben Sie Ihren Code ein.");
      return;
    }
    setIsSubmitting(true);
    try {
      const token = await getToken({ template: "fastapi" });
      const response = await fetch(`${getBackendURL()}/submit-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify({ code: trimmed }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        onSuccess?.();
        return;
      }
      setError(data.detail || "Der Code ist nicht korrekt.");
    } catch (err) {
      setError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.");
      console.error("Submit code error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Code eingeben
        </h1>
        <p className="text-gray-600 mb-6">
        Bitte geben Sie hier die Seminar-Nummer zu Ihrer PC-COLLEGE Schulung ein (diese finden Sie in der E-Mail zur Anmeldebestätigung).
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="code" className="block text-sm font-medium text-gray-700 mb-1">
              Code
            </label>
            <input
              id="code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="z. B. 7EG251208-B"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-orange-500 focus:border-orange-500"
              disabled={isSubmitting}
              autoFocus
            />
          </div>
          {error && (
            <p className="text-sm text-red-600" role="alert">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "Wird geprüft…" : "Code bestätigen"}
          </button>
        </form>
      </div>
    </div>
  );
}
